import { Dispatch } from "redux";

import {
  fetchApps,
  fetchAppById,
  createApp,
  updateApp,
  deleteApp,
} from "@api/procurements/annualProcurementPlan";

import { AnnualProcurementPlanStateAction } from "@reducers/types/procurements/annual-procurement-plan-state";

import { GET_APPS, GET_APP, CREATE_APP, UPDATE_APP, DELETE_APP } from "./types";
import {
  AnnualProcurementType,
  AnnualProcurementCreateType,
} from "@type/procurements/annualProcurementPlan";
import { PaginationRequestType } from "@type/procurements/pagination";

export const appFetchActionHandler =
  (query: PaginationRequestType) =>
  async (dispatch: Dispatch<AnnualProcurementPlanStateAction>) => {
    dispatch({ type: GET_APPS.LOADING, payload: true });

    try {
      const resData = await fetchApps(query);

      const { data, page, size, total } = resData || {};

      dispatch({
        type: GET_APPS.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_APPS.ERROR, payload: err });
    }
  };

export const appByIdFetchActionHandler =
  (id: string | number) =>
  async (dispatch: Dispatch<AnnualProcurementPlanStateAction>) => {
    dispatch({ type: GET_APP.LOADING, payload: true });

    try {
      const resData = await fetchAppById(id);

      dispatch({
        type: GET_APP.SUCCESS,
        payload: resData || {},
      });
    } catch (err) {
      dispatch({ type: GET_APP.ERROR, payload: err });
    }
  };

export const appCreateActionHandler =
  (data: AnnualProcurementCreateType) =>
  async (dispatch: Dispatch<AnnualProcurementPlanStateAction>) => {
    dispatch({ type: CREATE_APP.LOADING, payload: true });

    try {
      const res = await createApp(data);

      dispatch({ type: CREATE_APP.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_APP.ERROR, payload: err });
    }
  };

export const appUpdateActionHandler =
  (id: string | number, data: AnnualProcurementCreateType) =>
  async (dispatch: Dispatch<AnnualProcurementPlanStateAction>) => {
    dispatch({ type: UPDATE_APP.LOADING, payload: true });

    try {
      const res = await updateApp(data, id);

      dispatch({
        type: UPDATE_APP.SUCCESS,
        payload: { id },
      });
    } catch (err) {
      dispatch({ type: UPDATE_APP.ERROR, payload: false });
    }
  };

export const appDeleteActionHandler =
  (id: string | number) =>
  async (dispatch: Dispatch<AnnualProcurementPlanStateAction>) => {
    dispatch({ type: DELETE_APP.LOADING, payload: true });

    try {
      const res = await deleteApp(id);

      dispatch({ type: DELETE_APP.SUCCESS, payload: id });
    } catch (err) {
      dispatch({ type: DELETE_APP.ERROR, payload: err });
    }
  };
